// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"05b89be1","458":"24fba75e","774":"1a29691f","807":"6f0b3b3d","819":"d66bda29","858":"a9d6ff91","910":"eea1bdbb"}[chunkId] + ".chunk.js";
};